import GoodsTracking from "@/pages/ctd/GoodsTracking"
import GoodsTrackingMap from "@/pages/ctd/GoodsTrackingMap"
import Index from "@/pages/ctd/Index"
import Search from "@/pages/ctd/Search"
import Th from "@/pages/ctd/th/Index"
import ThOrder from "@/pages/ctd/th/Order"
import ThGoods from "@/pages/ctd/th/Goods"
import ThTrans from "@/pages/ctd/th/Trans"
import ThFiles from "@/pages/ctd/th/Files"
import Sh from "@/pages/ctd/sh/Index"
import ShOrder from "@/pages/ctd/sh/Order"
import ShGoods from "@/pages/ctd/sh/Goods"
import ShTrans from "@/pages/ctd/sh/Trans"
import ShFiles from "@/pages/ctd/sh/Files"
import Thd from "@/pages/ctd/Thd"
import Psd from "@/pages/ctd/Psd"
import Abnormal from "@/pages/ctd/Abnormal"
import Store from "@/pages/ctd/Store"
let router = [{
    path: "/ctd/goods_tracking",
    name: "goods_tracking",
    component: GoodsTracking,
    meta: {
      title: "货物跟踪",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/ctd/tracking_map",
    name: "tracking_map",
    component: GoodsTrackingMap,
    meta: {
      title: "运输轨迹",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/ctd/",
    name: "Index",
    component: Index,
    meta: {
      title: "TMS运输管理系统",
      keepAlive: true
    }
  }, {
    path: "/ctd/thd",
    name: "thd",
    component: Thd,
    meta: {
      title: "提货单",
      role: [0]
    }
  }, {
    path: "/ctd/psd",
    name: "psd",
    component: Psd,
    meta: {
      title: "送货单",
      role: [0]
    }
  }, {
    path: "/ctd/search",
    name: "search",
    component: Search,
    meta: {
      title: "搜索"
    }
  },
  {
    path: "/ctd/Store",
    name: "Store",
    component: Store,
    meta: {
      keepAlive: true,
      title: "WMS仓储管理系统",
      login: false // 是否需要登录
    }
  }, {
    path: "/ctd/th",
    name: "th",
    component: Th,
    meta: {
      title: "提货单"
    },
    children: [{
      path: "/ctd/th/order",
      name: "order",
      component: ThOrder,
      meta: {
        title: "提货单信息"
      },
    }, {
      path: "/ctd/th/goods",
      name: "goods",
      component: ThGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/ctd/th/trans",
      name: "trans",
      component: ThTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/ctd/th/files",
      name: "files",
      component: ThFiles,
      meta: {
        title: "回单"
      },
    }]
  }, {
    path: "/ctd/sh",
    name: "sh",
    component: Sh,
    meta: {
      title: "送货单"
    },
    children: [{
      path: "/ctd/sh/order",
      name: "order",
      component: ShOrder,
      meta: {
        title: "送货单信息"
      },
    }, {
      path: "/ctd/sh/goods",
      name: "goods",
      component: ShGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/ctd/sh/trans",
      name: "trans",
      component: ShTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/ctd/sh/files",
      name: "files",
      component: ShFiles,
      meta: {
        title: "回单"
      },
    }]
  },
  {
    path: "/ctd/abnormal",
    name: "abnormal",
    component: Abnormal,
    meta: {
      title: "异常反馈",
      role: [0]
    }
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/router/ctd.js